import { render, staticRenderFns } from "./news_trend.vue?vue&type=template&id=76698878&scoped=true"
import script from "./news_trend.vue?vue&type=script&lang=js"
export * from "./news_trend.vue?vue&type=script&lang=js"
import style0 from "./news_trend.vue?vue&type=style&index=0&id=76698878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76698878",
  null
  
)

export default component.exports